// @ts-check
import React, { useContext } from "react";
// router, intl
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
// component
import Centrality from "./centrality/Centrality";
import PageRank from "./pageRank/PageRank";
import BottomPanel from "./bottomPanel/BottomPanel";
import { StoreContext } from "../../../../../store/StoreProvider";
// hook
import useLocaleRoute from "../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../hooks/useModulePublic";
// config,utils,css
import urls from "../../../../../api/project/ApiUrls";
import fireAuth from "../../../../../api/firebase/auth/utils";

const AnalyticsTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  //
  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);
  // const isLoggedIn = true;

  return (
    <Box sx={{ overflow: "auto" }}>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="h6"
          sx={{
            color: "#fff",
          }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--analytics-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.analyticstool.title",
            defaultMessage: "數據分析",
          })}
        </Typography>
      </Box>
      <Centrality />
      {/* <PageRank /> */}
      <BottomPanel />
    </Box>
  );
};

export default AnalyticsTool;
